import React from "react";
import { Box, Typography, Paper } from "@material-ui/core";

function AboutThisReportTab({ }) {
    return (
        <Box display="flex" justifyContent="center" width="100%" mt={2}>
            <Paper
                elevation={0}
                style={{
                    maxWidth: 1300,
                    minHeight: 510,
                    width: "100%",
                    margin: "0 auto",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "40px 36px 32px 36px",
                }}
            >
                <Typography style={{ marginBottom: 12 }}>
                    This report is designed as a practical tool to support educators in positively guiding students toward becoming AI-ready. Use it as a foundational resource to facilitate meaningful conversations and actions that enhance students' digital competencies, safety, and well-being.
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 10 }}>
                    Recommendations for Educators:
                </Typography>
                <Box component="ul" pl={3} mb={2} style={{ marginTop: 0 }}>
                    <li style={{ marginBottom: 6 }}>
                    <span style={{ color: "#ff5758", fontWeight: 700 }}>
                       Foster Open Communication:
                    </span>{" "}
                        Encourage open and supportive conversations with students about their digital experiences. Listen actively to better understand and address their needs and concerns.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                    <span style={{ color: "#ff5758", fontWeight: 700 }}>
                       Positive Guidance:
                    </span>{" "}
                        Use the insights from this report to positively reinforce safe, responsible, and effective use of digital technology. Celebrate areas of strength while constructively addressing areas needing improvement.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                    <span style={{ color: "#ff5758", fontWeight: 700 }}>
                        Implement Constructive Policies:
                    </span>{" "}
                        Clearly define and communicate classroom policies related to device use, internet safety, and responsible digital interactions. Policies should emphasize care, safety, and the practical benefits of being digitally responsible.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                    <span style={{ color: "#ff5758", fontWeight: 700 }}>
                        Teach Digital and AI Skills:
                    </span>{" "}
                        Integrate lessons and activities that equip students with essential digital literacy and AI-related skills. Highlight real-world applications and encourage critical thinking and responsible usage.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                    <span style={{ color: "#ff5758", fontWeight: 700 }}>
                        Model Responsible Behavior:
                    </span>{" "}
                        Demonstrate positive digital habits and mindful online interactions. Your example reinforces students' understanding of responsible digital citizenship and AI use.
                    </li>
                </Box>
                 <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 10 }}>
                     Important Considerations:
                 </Typography>
                <Box component="ul" pl={3} mb={2} style={{ marginTop: 0 }}>
                 <li style={{ marginBottom: 6 }}>
                     Avoid overly restrictive or punitive measures, which may discourage students from openly discussing digital issues.
                 </li>
                 <li style={{ marginBottom: 6 }}>
                     Respond thoughtfully and calmly to challenges or issues identified in the report, focusing on solutions and positive improvements.
                 </li>
                 <li style={{ marginBottom: 6 }}>
                     Recognize that building digital and AI skills is a collaborative effort requiring ongoing engagement between educators, students, and families.
                 </li>
             </Box>

                <Typography
                    variant="body2"
                    style={{
                        color: "#444",
                        fontSize: 13,
                        fontStyle: "italic",
                        marginTop: 20,
                        borderTop: "1px solid #f2f2f2",
                        paddingTop: 16,
                    }}
                >
                    <b>Disclaimer</b>
                    <br />
                    <span style={{ fontStyle: "normal", fontWeight: 400 }}>
                    <i>
                    Limitations of Content: This report provides a detailed snapshot of the digital competencies and safety of students based on their self-reported responses. The accuracy of the report depends entirely on the honesty and accuracy of these responses. It does not constitute legal or medical advice.
                    <br />
                    <br />
                    Confidentiality: This report may contain sensitive personal information and should only be accessed by authorized educational professionals and the students' parents or guardians with legal permission.
                    </i>
                </span>
                </Typography>
            </Paper>
        </Box>
    );
}

export default AboutThisReportTab;